// The API answers 429 when a ticker was synced too often. The body carries how many
// seconds to wait: { status: "Error", data: { code: "SYNC_RATE_LIMITED", retry_after: 212 } }.
// callApi hands that body back as error.data.

const FALLBACK_WAIT_SECONDS = 60;

/** Seconds to wait when the error is a 429, or null for any other error. */
export const getSyncRetrySeconds = (error: any): number | null => {
  if (error?.status !== 429) return null;
  const seconds = Number(error?.data?.data?.retry_after);
  return Number.isFinite(seconds) && seconds > 0
    ? Math.ceil(seconds)
    : FALLBACK_WAIT_SECONDS;
};

/** 212 -> "3:32", 3725 -> "1:02:05" */
export const formatCountdown = (totalSeconds: number): string => {
  const seconds = Math.max(0, Math.ceil(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const rest = String(seconds % 60).padStart(2, "0");
  return hours > 0
    ? `${hours}:${String(minutes).padStart(2, "0")}:${rest}`
    : `${minutes}:${rest}`;
};
